module.exports = __webpack_public_path__ + "img/mapfarm1.8efaaa81.jpeg";